import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import _ from 'lodash'

import Step from './flow/Step'
import FlowNav from './flow/FlowNav'
import { Prompt } from 'Src/history'
import { getBotById } from 'Src/reselect/bots'

import { getActiveFlow, getFlowHasUnsavedChanges, getFlowHistory } from 'Selectors/flow'
import { BotContext, FlowContext } from './contexts'

import { initFlowPage } from 'Actions/flow'
import { fetchGuides } from 'Actions/guides'
import { fetchAnswers } from 'Actions/answers'
import { fetchAccount } from 'Actions/account'

const FlowContainer = () => {
  const params = useParams()
  const botId = params.botId

  const bot = useSelector((state) => getBotById(state, botId))

  if (!bot) {
    return null
  }

  return <Flow botProfile={bot} />
}

export const Flow = (props) => {
  const { container, botProfile } = props

  const dispatch = useDispatch()
  const params = useParams()
  const botId = params.botId
  const flowId = params.flowId

  const activeFlow = useSelector(getActiveFlow)
  const flowHistory = useSelector(getFlowHistory)
  const flowHasUnsavedChanges = useSelector(getFlowHasUnsavedChanges)

  const { settings, conversation, id, latest_published_revision: latestPublishedRevision } = activeFlow

  useEffect(() => {
    dispatch(initFlowPage({ botId, flowId }))
    dispatch(fetchAccount())
    dispatch(fetchGuides())
    dispatch(fetchAnswers())
  }, [dispatch, botId, flowId])

  if (_.isEmpty(conversation)) {
    return null
  }

  const paths = _.split(flowHistory, '.')

  const flowContextValue = {
    id: flowId,
    steps: conversation.steps,
    starting_step_id: conversation.starting_step_id,
    isNewUI: container && container === 'newDesign'
  }

  return (
    <BotContext.Provider value={botProfile}>
      <FlowContext.Provider value={flowContextValue}>
        <div className='flow-page'>
          <Prompt
            when={flowHasUnsavedChanges}
            message='Your changes has not been saved. Are you sure you want to leave this page?'
          />
          <FlowNav
            botId={botId}
            flowId={id}
            embedToken={botProfile.embed_token}
            conversation={conversation}
            settings={settings}
            latestPublishedRevision={latestPublishedRevision}
            container={container}
          />

          <div className='flow-cover'>
            <div className='flow-wrapper'>
              <div style={{ scroll: 100 }} className='steps-wrapper'>
                {_.map(paths, (stepId, index) => {
                  return <Step row={index + 1} stepId={stepId} key={stepId + index} />
                })}
              </div>
            </div>
          </div>
        </div>
      </FlowContext.Provider>
    </BotContext.Provider>
  )
}

export default FlowContainer
